// extracted by mini-css-extract-plugin
var _1 = "o5EMipegVTvyE0LIOn8l";
var _2 = "a7LtUMaHF1FldHqsXGWz";
var _3 = "qBFB7731llUxrgHNPU16";
var _4 = "BJhxfSpMfzaqRP3txvWL";
var _5 = "MeU9dxi5Je88O2r_2haL";
var _6 = "zcW_SkyG6ca64wzMHE2T";
var _7 = "oChWkwn8p5s4zyBuEOCr";
export { _1 as "shortcutsBlock", _2 as "shortcutsCol", _3 as "shortcutsHeading", _4 as "shortcutsItem", _5 as "shortcutsLink", _6 as "shortcutsScrollBtn", _7 as "shortcutsWrapper" }
